import React from "react";
import {AddressType, getPendingUploadCount} from "../types/Address";
import {getTaskTypeName, TaskImageTypeTranslationId} from "../types/Task";
import {useManageContext} from "../App";
import TotalTimeDetail from "./TotalTimeDetail";
import TotalKmDetail from "./TotalKmDetail";
import i18n from "../lang/i18n";
import {Link, useParams, useSearchParams} from "react-router-dom";
import TotalLdmDetail from "./TotalLdmDetail";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({Address, onlyWithPendingTasks = false, ldm = null, isNextStop}: {
    Address: AddressType,
    onlyWithPendingTasks?: boolean,
    ldm: number | null,
    isNextStop: boolean,
}) => {

    const {tripKey} = useParams();
    const {lang} = useManageContext();
    const [searchParams] = useSearchParams();

    const TourId = searchParams.get('TourId');

    const getPendingDetails = (): string => {
        const details = getPendingUploadCount([Address]);
        let detailsText = '';

        // @ts-ignore
        Object.keys(details).forEach((key: 'CMR' | 'TEMP' | 'PLL' | 'IMAGE' | 'total') => {
            const count = details[key];
            if (count > 0 && key !== 'total') {
                if (detailsText !== '') {
                    detailsText += ', ';
                }
                detailsText += count > 0 ? i18n.t(String(TaskImageTypeTranslationId[key])) + ' (' + count + ')' : '';
            }
        });

        return detailsText;
    }

    if (!Address) {
        return null;
    }

    return <div>
        <Link to={isNextStop
            ? '/next-stop/' + tripKey + (TourId ? '?TourId=' + TourId : '')
            : '/address/' + tripKey + '/' + Address.Tasks[0].TaskGuid + (TourId ? '?TourId=' + TourId : '')
        } className="text-decoration-none text-body">
            <div className="px-3 pb-3 position-relative">
                { Address.TaskCountInAddress > 1 && <div className="task-count-in-address">{Address.TaskCountInAddress}</div> }
                <div className="row">
                    <div className="col-8">
                        <h4 style={{fontWeight: 'bold'}}>{Address.AddressSequenceMain}. {getTaskTypeName(Address.TaskType, Address.AdditionalStopTypeId, lang)}</h4>
                        {Address.LoadingDeliveryCompany.length > 1 && <h6>{Address.LoadingDeliveryCompany}</h6>}
                        <p className="mb-0">{Address.FullAddress}</p>
                        {Address.AddressTotalCargoDescriptionHtml &&
                            <div dangerouslySetInnerHTML={{
                                __html: Address.AddressTotalCargoDescriptionHtml,
                            }}></div>}
                    </div>
                    <div className="col-4 d-flex justify-content-end align-items-center">
                        <div>
                            {Address.BadgeText !== '' &&
                                <small className="badge bg-warning">{Address.BadgeText}</small>}
                            {Address.PlannedArrivalDate && <p>{Address.PlannedArrivalDate}</p>}
                            <div className="row">
                                {Address.PlannedArrivalTime && <p>{Address.PlannedArrivalTime}</p>}
                                {Address.PlannedArrivalDateFix && <div className="badge bg-danger">
                                    <small className="text-light">FIX</small>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                {!onlyWithPendingTasks && <div>
                    <p className="fw-bold text-danger">{i18n.t('2638')}</p>: {getPendingDetails()}
                </div>}
            </div>

            {onlyWithPendingTasks && Address.MinTillNextStop > 0 && Address.KmTillNextStop > 0 ?
                <div className="d-flex bg-secondary-container align-items-center py-1 px-4 mb-3 justify-content-between">
                    <div className="d-flex justify-content-between">
                        <TotalTimeDetail Min={Address.MinTillNextStop}/>
                        <div className="ps-4">
                            <TotalKmDetail Km={Address.KmTillNextStop}/>
                        </div>
                    </div>
                    <div>
                        <TotalLdmDetail ldm={ldm}/>
                    </div>
                </div>
                : <div className="bg-secondary-container py-1 mb-3"></div>}
        </Link>
    </div>;
}